var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6044 4.74921C21.5481 5.00363 22.2922 5.74869 22.5462 6.69366C23.0181 8.42003 22.9999 12.0182 22.9999 12.0182C22.9999 12.0182 22.9999 15.5981 22.5462 17.3245C22.2922 18.2694 21.5481 19.0145 20.6044 19.2689C18.8804 19.7232 11.9842 19.7232 11.9842 19.7232C11.9842 19.7232 5.10615 19.7232 3.36396 19.2507C2.42027 18.9963 1.67621 18.2513 1.42214 17.3063C0.968445 15.5981 0.968445 12 0.968445 12C0.968445 12 0.968445 8.42003 1.42214 6.69366C1.67621 5.74869 2.43842 4.98545 3.36396 4.73104C5.08801 4.27673 11.9842 4.27673 11.9842 4.27673C11.9842 4.27673 18.8804 4.27673 20.6044 4.74921ZM15.5206 11.8374L9.74852 15.1706V8.50424L15.5206 11.8374Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social-youtube.6ea02d66d4b806b315cb5e50f7403a20.svg";
export { ForwardRef as ReactComponent };